export enum AnimationKeys {
  WoodPole = "wood-ring",
  GoldPole = "gold-ring",
  CandyPole = "candy-ring",
}

export enum AudioKeys {
  Ambience = "ambience",
  Cheer = "cheer",
}

export enum SceneKeys {
  Preloader = "preloader",
  Practise = "practise",
  Game = "game",
  GameOver = "game-over",
}

export enum TextureKeys {
  Shelf = "shelf",
  Ring = "ring",
  WoodPole = "wood-pole",
  GoldPole = "gold-pole",
  CandyPole = "candy-pole",
}
